import { FrenchLegalStatus } from '../../invoicingSettings/enums/frenchLegalStatus'

const legalStatusWithNotRequiredSharedCapital = [
  FrenchLegalStatus.Association,
  FrenchLegalStatus.Auto,
  FrenchLegalStatus.EI,
]

type GetIsRequiredSharedCapitalProps = {
  legalStatus?: string
  sharedCapital?: number
}

export const getIsRequiredSharedCapital = ({ legalStatus, sharedCapital }: GetIsRequiredSharedCapitalProps) =>
  !legalStatusWithNotRequiredSharedCapital.some((status) => status === legalStatus) && !sharedCapital
